module.exports = __webpack_public_path__ + "img/dd-logo-mazda-w.3ff0c02a.png";